module.exports = __webpack_public_path__ + "static/media/favicon.84e8a8b1.ico";